import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const pressQuotes = [{
  source: 'Variety',
  quote: 'The most insane competition show ever created. MrBeast has completely redefined the genre.'
}, {
  source: 'Forbes',
  quote: 'A production scale that rivals major Hollywood blockbusters. Beast Games is a phenomenon.'
}, {
  source: 'Entertainment Weekly',
  quote: "Heart-pounding action from start to finish. You won't be able to look away."
}, {
  source: 'The Verge',
  quote: "YouTube's biggest creator conquers streaming with absolute confidence and spectacle."
}];
export function TestimonialsSection() {
  return <section className="w-full py-24 bg-[#0a0a12] relative overflow-hidden" data-id="element-151">
      <div className="max-w-7xl mx-auto px-6" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-153">
          <h2 className="font-oswald text-4xl md:text-6xl font-bold text-white uppercase tracking-wider" data-id="element-154">
            What They Are <span className="text-[#ffd700]" data-id="element-155">Saying</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-156">
          {pressQuotes.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#16213e] p-8 md:p-12 rounded-xl border border-white/5 relative group hover:border-[#ffd700]/30 transition-colors" data-id="element-157">
              <Quote className="w-10 h-10 text-[#ffd700]/20 mb-6" data-id="element-158" />
              <p className="text-xl md:text-2xl text-gray-200 font-light italic leading-relaxed mb-8" data-id="element-159">
                "{item.quote}"
              </p>
              <div className="flex items-center" data-id="element-160">
                <div className="h-px flex-1 bg-white/10 mr-4" data-id="element-161" />
                <span className="font-oswald text-lg text-[#ffd700] uppercase tracking-widest font-bold" data-id="element-162">
                  {item.source}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}